/** Opening acknowledgement: reply-style body inside Zoho/Outlook outer+inner containers. */

import { preserveEmailBlankLines } from './ticketEmailSignature';

export const OPENING_ACK_LOGO_URL = 'https://portal.banteckhan.com.sg/bth-logo.png';

/** Default reply-style body (Calibri-friendly). Logo sits top-right like compose. */
export const DEFAULT_OPENING_ACK_INNER = `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%;border-collapse:collapse;">
  <tr>
    <td valign="top" style="font-size:0;line-height:0;">&nbsp;</td>
    <td valign="top" align="right" width="160" style="width:160px;padding:0 0 12px 12px;">
      <img src="${OPENING_ACK_LOGO_URL}" width="160" alt="BTH" border="0" style="display:block;border:0;width:160px;max-width:160px;height:auto;" />
    </td>
  </tr>
</table>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Dear {{requester_name}},</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Thanks for getting in touch! We've created a ticket for you with the ID <strong>{{ticket_number}}</strong> about '{{subject}}'</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Our Sales &amp; Marketing team members will take a look and respond to you shortly.</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">If you need further assistance, please feel free to contact us at the following addresses:</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<ul style="margin:0;padding-left:22px;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">
  <li style="margin:0 0 4px 0;"><strong>Orders:</strong> <a href="mailto:orders@banteckhan.com.sg">orders@banteckhan.com.sg</a></li>
  <li style="margin:0 0 4px 0;"><strong>Enquiries &amp; Feedback:</strong> <a href="mailto:enquiry@banteckhan.com.sg">enquiry@banteckhan.com.sg</a></li>
  <li style="margin:0 0 4px 0;"><strong>Account &amp; Finance:</strong> <a href="mailto:acct@banteckhan.com.sg">acct@banteckhan.com.sg</a></li>
  <li style="margin:0 0 4px 0;"><strong>Human resources:</strong> <a href="mailto:hr1@banteckhan.com.sg">hr1@banteckhan.com.sg</a></li>
</ul>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Regards,</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Sales &amp; Marketing Team</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">BTH Tech Hill Enterprise (S) Pte. Ltd. A member of TBC Group</p>`;

export const DEFAULT_CLOSING_ACK_INNER = `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%;border-collapse:collapse;">
  <tr>
    <td valign="top" style="font-size:0;line-height:0;">&nbsp;</td>
    <td valign="top" align="right" width="160" style="width:160px;padding:0 0 12px 12px;">
      <img src="${OPENING_ACK_LOGO_URL}" width="160" alt="BTH" border="0" style="display:block;border:0;width:160px;max-width:160px;height:auto;" />
    </td>
  </tr>
</table>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Dear {{requester_name}},</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">We have closed ticket <strong>{{ticket_number}}</strong> about '{{subject}}'.</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">If you need further help, reply to this email and we will reopen the ticket.</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">&nbsp;</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Regards,</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">Sales &amp; Marketing Team</p>
<p style="margin:0;line-height:1.15;font-family:Calibri,'Segoe UI',sans-serif;font-size:11pt;">BTH Tech Hill Enterprise (S) Pte. Ltd. A member of TBC Group</p>`;

/**
 * Outer gray canvas + inner white card (Outlook-safe tables).
 * Editor only edits the marked inner body; shell is applied on save/send/preview.
 */
export function wrapOpeningAckBody(innerHtml: string): string {
  const inner = (innerHtml || '').trim() || DEFAULT_OPENING_ACK_INNER;
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<body style="margin:0;padding:0;background-color:#f2f3f5;">
<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f2f3f5" style="background-color:#f2f3f5;width:100%;border-collapse:collapse;">
  <tr>
    <td align="center" bgcolor="#f2f3f5" style="background-color:#f2f3f5;padding:16px 8px;">
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#ffffff" style="width:100%;max-width:760px;background-color:#ffffff;border:1px solid #d8dce0;border-collapse:collapse;">
        <tr>
          <td bgcolor="#ffffff" style="background-color:#ffffff;padding:20px 28px 28px 28px;font-family:Calibri,'Segoe UI',Arial,sans-serif;font-size:11pt;color:#222222;line-height:1.15;">
<!-- ack-body-start -->
${inner}
<!-- ack-body-end -->
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</body>
</html>`;
}

/** Strip outer/inner shells so TipTap only edits the reply body. */
export function extractOpeningAckBody(fullHtml: string): string {
  const raw = (fullHtml || '').trim();
  if (!raw) return DEFAULT_OPENING_ACK_INNER;

  const marked = raw.match(
    /<!--\s*ack-body-start\s*-->([\s\S]*?)<!--\s*ack-body-end\s*-->/i,
  );
  if (marked?.[1]?.trim()) return marked[1].trim();

  if (/<!DOCTYPE|<html[\s>]|#f2f3f5|#e8eaed/i.test(raw)) {
    try {
      const doc = new DOMParser().parseFromString(raw, 'text/html');
      const cells = Array.from(doc.querySelectorAll('td'));
      const contentCell =
        cells.find((td) => /Dear\s|\{\{\s*requester_name\s*\}\}/i.test(td.textContent || '')) ??
        null;
      if (contentCell) {
        const html = (contentCell.innerHTML || '').trim();
        if (html) return html;
      }
      const body = doc.body?.innerHTML?.trim();
      if (body) return body;
    } catch {
      /* fall through */
    }
  }

  return raw;
}

/** Persist full email (gray outer + white inner + reply body). Blank Enter lines kept as &nbsp;. */
export function toStoredOpeningAckBody(editorHtml: string): string {
  const inner = preserveEmailBlankLines(extractOpeningAckBody(editorHtml).trim());
  return wrapOpeningAckBody(inner || DEFAULT_OPENING_ACK_INNER);
}

export function previewOpeningAckHtml(
  subjectTemplate: string,
  bodyTemplate: string,
  sample: { ticket_number: string; requester_name: string; subject: string },
): { subject: string; html: string } {
  const vars: Record<string, string> = {
    ticket_number: sample.ticket_number,
    requester_name: sample.requester_name,
    subject: sample.subject,
    requester_email: '',
    customer_name: sample.requester_name,
  };
  const render = (tpl: string) =>
    tpl.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (_, key: string) => vars[key.toLowerCase()] ?? '');

  const body = toStoredOpeningAckBody(bodyTemplate);
  return {
    subject: render(subjectTemplate),
    html: render(body),
  };
}
